import React, { useState, useEffect } from "react"
import { X } from "lucide-react"
import { useTranslation } from "react-i18next"

const FIELD_KEYS = [
  { key: "hotel_name", labelKey: "hotel" },
  { key: "star_name", labelKey: "stars" },
  { key: "region_name", labelKey: "region" },
  { key: "resort_name", labelKey: "resort" },
  { key: "date_entry", labelKey: "check_in" },
  { key: "date_out", labelKey: "check_out" },
  { key: "nights", labelKey: "nights", type: "number" },
  { key: "food_name", labelKey: "meal_plan" },
  { key: "type_room_name", labelKey: "room_type" },
  { key: "price", labelKey: "base_price", type: "number" },
]

const buildForm = (tour) =>
  FIELD_KEYS.reduce((acc, f) => ({ ...acc, [f.key]: tour?.[f.key] ?? "" }), {})

const EditTourModal = ({ open, onClose, onSubmit, tour }) => {
  const { t } = useTranslation()
  const [form, setForm] = useState(() => buildForm(tour))

  useEffect(() => {
    if (open) setForm(buildForm(tour))
  }, [open, tour])

  if (!open) return null

  const handleChange = (key) => (e) => setForm((f) => ({ ...f, [key]: e.target.value }))
  const handleSubmit = (e) => {
    e.preventDefault()
    onSubmit(form)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30 p-4">
      <div className="bg-white rounded-2xl shadow-lg w-full max-w-md p-5 max-h-[85vh] overflow-y-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-[#1F2733]">{t("saved_tours.edit.title")}</h3>
          <button onClick={onClose} className="text-[#9AA5B4] hover:text-[#5A6779]">
            <X size={18} />
          </button>
        </div>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          {FIELD_KEYS.map((f) => (
            <label key={f.key} className="flex flex-col gap-1 text-xs text-[#5A6779]">
              {t(`saved_tours.edit.${f.labelKey}`)}
              <input
                type={f.type || "text"}
                value={form[f.key]}
                onChange={handleChange(f.key)}
                className="border border-[#E7EAEF] rounded-lg px-3 py-2 text-sm"
              />
            </label>
          ))}
          <div className="flex justify-end gap-2 mt-2">
            <button type="button" onClick={onClose} className="text-sm text-[#5A6779] px-3 py-2">
              {t("saved_tours.edit.cancel")}
            </button>
            <button type="submit" className="text-sm text-white bg-[#26303D] rounded-lg px-4 py-2">
              {t("saved_tours.edit.save")}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default EditTourModal
